class SlideUpAnimation {
  constructor(container) {
    this.contentSelector = container;
    this.contentBoxes = [];
    this.init();
  }

  init() {
    this.contentBoxes = document.querySelectorAll(this.contentSelector);
    this.handleScroll = this.handleScroll.bind(this);

    this.contentBoxes.forEach((box, index) => {
      if (index === 0) {
        box.classList.add('already-visible');
      }
    });

    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  isInViewport(element, delayThreshold = 100) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight - delayThreshold && rect.bottom > 0;
  }

  handleScroll() {
    this.contentBoxes.forEach((box) => {
      const images = box.querySelectorAll('img');

      if (this.isInViewport(box, 150)) {
        box.classList.add('active');

        images.forEach((image) => {
          if (this.isInViewport(image)) {
            const rect = image.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            const startZoomZone = windowHeight * 0.3;
            const endZoomZone = windowHeight * 1.2;

            const distanceFromTop = rect.top;
            const zoomFactor =
              1 +
              ((endZoomZone - distanceFromTop) /
                (endZoomZone - startZoomZone)) *
                0.01;
            image.style.zoom = zoomFactor;
          } else {
            image.style.zoom = 1;
          }
        });
      } else {
        box.classList.remove('active');
        images.forEach((image) => {
          image.style.zoom = 1;
        });
      }
    });
  }

  update() {
    this.contentBoxes = document.querySelectorAll(this.contentSelector);
    this.handleScroll();
  }
}

// ✅ Mobile-only check
function isMobileDevice() {
  return window.innerWidth >= 768; // You can adjust the breakpoint if needed
}

document.addEventListener('DOMContentLoaded', function () {
  if (isMobileDevice()) {
    new SlideUpAnimation('main .shopify-section');
  }
});
